import React, { useEffect, useState, useMemo, useRef } from "react";
import "../../StyleSheet/MainComponent/Role/Role.scss";
import { useDispatch, useSelector } from "react-redux";
import { json, useNavigate } from "react-router-dom";
import {
  RetrieveInvoiceActions,
  setprojectListgetdropActions,
  setplantListgetdropActions,
  setprojectwbsListgetdropActions,
} from "../../Redux/Slice";
import ReactTable from "../../Component/AppComponent/Table";
import home from "../../Assets/AppComponent/Logo/Home.svg";
import emailDash from "../../Assets/AppComponent/Images/emailDash.svg";

import Header from "../../Component/AppComponent/Header/Header";
import { DateRangePicker, SelectPicker } from "rsuite";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import axios from "axios";
import { exceldatadownloadapi } from "../../Context/apidata";
import { store } from "../../Redux/Store";
import Select from "react-select";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { FaRegFilePdf } from "react-icons/fa6";

const Role = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );
  const UserData = useSelector((state) => state.users.UserData);
  const [downloadType, setDownloadType] = useState("excel");

  const navigate = useNavigate();
  const RetrieveInvoiceRes = useSelector((state) => state.RetrieveInvoiceData);
  const dispatch = useDispatch();
  const [tabledata, settabledata] = useState([]);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [datacount, setdatacount] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [tableDatacount, setTableDatacount] = useState(0);
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const [defaultvalue, setdefaultvalue] = useState([
    { value: "all", label: "All" },
  ]);
  const [plantNameFeeder, setPlantNameFeeder] = useState([]);
  const [projectNameFeeder, setProjectNameFeeder] = useState([]);
  const [projectWbsNameFeeder, setProjectWbsNameFeeder] = useState([]);

  const [plantSelected, setPlantSelected] = useState([
    { value: "all", label: "All" },
  ]);
  const [projectSelected, setProjectSelected] = useState([
    { value: "all", label: "All" },
  ]);
  const [projectWbsSelected, setProjectWbsSelected] = useState([
    { value: "all", label: "All" },
  ]);
  const [clientStatus, setClientStatus] = useState("all");
  const clientStatusData = [
    { label: "All", value: "all" },
    { label: "UDS PORTAL", value: true },
    { label: "OTHER PORTAL", value: false },
  ];
  const [emailStatus, setEmailStatus] = useState("all");
  const emailStatusData = [
    { label: "All", value: "all" },
    { label: "Sent", value: true },
    { label: "Failed", value: false },
  ];
  useEffect(() => {
    console.log(UserData, "KJSAJDKASJKDJKASKJDKJSA");
  }, []);

  const [email, setEmail] = useState(true);
  console.log(emailStatus, "kjncncncsjhdsjkd", clientStatus, email);
  const plantNames = useSelector(
    (state) => state.plantListgetdropdata.plantListgetdrop,
  );
  const projectNames = useSelector(
    (state) => state.projectListgetdropdata.projectListgetdrop,
  );
  const projectWbsNames = useSelector(
    (state) => state.projectwbsListgetdropdata.projectwbsListgetdrop,
  );

  useEffect(() => {
    setPlantNameFeeder(plantNames);
  }, [plantNames]);

  useEffect(() => {
    setProjectNameFeeder(projectNames);
  }, [projectNames]);
  // <---------Setting project wbs list in ProjectWbsNameFeeder.--------------->

  useEffect(() => {
    setProjectWbsNameFeeder(projectWbsNames);
  }, [projectWbsNames]);

  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(today);
  var gt = convert(priorDate);
  const [range, setrange] = useState([it, it]);
  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  useEffect(() => {
    dispatch(
      RetrieveInvoiceActions({
        search: searchQuery,
        date_gt: range[0],
        date_lt: range[1],
        page: dtpageindex,
        client_status: clientStatus,
        email_status: emailStatus,
        plant: plantSelected[0]?.value ? plantSelected[0]["value"] : null,
        project: projectSelected[0]?.value ? projectSelected[0]["value"] : null,
        project_wbs: projectWbsSelected[0]?.value
          ? projectWbsSelected[0]["value"]
          : null,
      }),
    );
  }, [
    searchQuery,
    emailStatus,
    clientStatus,
    range,
    dtpageindex,
    plantSelected,
    projectSelected,
    projectWbsSelected,
    dispatch,
  ]);

  useEffect(() => {
    //console.log(RetrieveInvoiceRes);
    if (RetrieveInvoiceRes?.RetrieveInvoiceData?.data) {
      settabledata(RetrieveInvoiceRes.RetrieveInvoiceData.data);
      setdatacount(RetrieveInvoiceRes?.RetrieveInvoiceData);
      setTableDatacount(RetrieveInvoiceRes?.RetrieveInvoiceData?.values);

      console.log(RetrieveInvoiceRes.RetrieveInvoiceData, "dsdlkmklmdkllkdsa");
    } else {
      settabledata([]);
    }
  }, [RetrieveInvoiceRes]);
  const breadcrumbsData = [
    {
      id: "1",
      href: "/",
      source: emailDash,
      title: "MAIL DASHBOARD",
    },
  ];
  const adminBreadcrumbsData = [
    {
      id: "1",
      href: "/",
      source: emailDash,
      title: "MAIL DASHBOARD",
    },
  ];
  function formatArray(arr) {
    return JSON.stringify(
      arr.map((str) =>
        str?.length > 30 ? str?.substring(0, 30) + "..." : str,
      ),
    );
  }
  const formatInRupees = (value) => {
    return value.toLocaleString("en-IN", {
      style: "currency",
      currency: "INR",
    });
  };
  const InvoiceColumn = useMemo(
    () => [
      {
        Header: "Created Date",
        accessor: "",
        Cell: (row) => {
          var dateTimeString = row.row.original.created_at;

          // Split the string into date and time parts using 'T' as the delimiter
          var parts = dateTimeString.split("T");

          // Extract date and time
          var datePart = parts[0]; // "2024-05-13"
          var timePart = parts[1]; // "13:23:47.348708"
          return (
            <>
              <span>Date: {datePart} </span>
              <br></br>
              <span>Time: {timePart}</span>
            </>
          );
        },
      },
      {
        Header: "Customer Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                {row.row.original.project != null
                  ? row.row.original.project.c_name
                  : "--"}
              </span>
            </>
          );
        },
      },

      {
        Header: "Plant",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                {row.row.original.plant != null
                  ? row.row.original.plant.plant
                  : "--"}
              </span>
            </>
          );
        },
      },
      {
        Header: "Project",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                {row.row.original.project != null
                  ? row.row.original.project.project
                  : "--"}
              </span>
            </>
          );
        },
      },
      {
        Header: "Project Wbs",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {/* <div
                style={{
                  width: "50%",
                  margin: "0 auto",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              > */}
              <span>
                {row.row.original.project_wbs != null
                  ? row.row.original.project_wbs.project_wbs
                  : "--"}
              </span>
              {/* </div> */}
            </>
          );
        },
      },
      {
        Header: "Status",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {/* <div
                style={{
                  width: "50%",
                  margin: "0 auto",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              > */}
              <span>
                {/* {row.row.original.project_email_status
                  ? row.row.original.email_status == true
                    ? "Sent"
                    : "Failed"
                  : "Offsystem"} */}
                {row.row.original.email_status == true
                  ? row.row.original.project_email_status == true
                    ? "Sent"
                    : "Offsystem"
                  : "Failed"}
              </span>
              {/* </div> */}
            </>
          );
        },
      },
      {
        Header: "Invoice Count",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {/* <div
                style={{
                  width: "50%",
                  margin: "0 auto",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              > */}
              <span>
                {row.row.original.invoice_id != null
                  ? row.row.original.invoice_id.length
                  : "--"}
              </span>
              {/* </div> */}
            </>
          );
        },
      },
      {
        Header: "Invoice Amount",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {/* <div
                style={{
                  width: "50%",
                  margin: "0 auto",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              > */}
              <span>
                {row.row.original.amount != null
                  ? formatInRupees(row.row.original.amount)
                  : "--"}
              </span>
              {/* </div> */}
            </>
          );
        },
      },

      {
        Header: "Documents",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {/* <div
                style={{
                  width: "50%",
                  margin: "0 auto",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              > */}
              {row.row.original.invoice_zip != null ? (
                <a
                  href={row.row.original.invoice_zip}
                  onClick={(e) => {
                    const parts = row.row.original.invoice_zip.split("/media");
                    const urlAfterMedia =
                      parts.length > 1 ? "/media" + parts[1] : "";
                    //console.log(urlAfterMedia);
                    window.open(String(row.row.original.invoice_zip), "_blank");
                  }}
                >
                  Download Invoice
                </a>
              ) : (
                "--"
              )}
              {/* </div> */}
            </>
          );
        },
      },
    ],
    [],
  );

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },

    {
      label: "Last week",
      closeOverlay: false,
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      appearance: "default",
    },
    {
      label: "Next week",
      closeOverlay: false,
      value: (value, index) => {
        // //console.log(value);
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), 7),
        ];
      },
      appearance: "default",
    },
  ];
  const handlechangedate = (name, value) => {
    // let data =value.slice(0, 10)
    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };
  const exceldatadownload = (type) => {
    window.open(
      exceldatadownloadapi +
        `?date_gt=${range[0]}&date_lt=${range[1]}&client_status=${clientStatus}&export_type=${type}&email_status=${emailStatus}&type=sent&id=${
          store.getState().users.UserData.data.id
        }`,
      "_blank",
    );
  };

  useEffect(() => {
    dispatch(setplantListgetdropActions());
  }, []);

  useEffect(() => {
    if (plantSelected.length !== 0) {
      if (plantSelected[0].value != "all") {
        dispatch(setprojectListgetdropActions({ id: plantSelected[0].value }));
      }
    }
  }, [plantSelected, projectSelected, dispatch]);

  useEffect(() => {
    if (projectSelected.length !== 0) {
      if (projectSelected[0].value != "all") {
        dispatch(
          setprojectwbsListgetdropActions({ id: projectSelected[0].value }),
        );
      }
    }
  }, [projectSelected, dispatch]);

  useEffect(() => {
    if (projectWbsSelected.length !== 0) {
    }
  }, [projectWbsSelected, projectSelected, dispatch]);

  const customStyles = {
    option: (base, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...base,
        background: isFocused
          ? "rgba(242, 102, 57, 0.7)"
          : isDisabled
            ? "rgb(255,255,255)"
            : "transparent",
        color: isFocused ? "white" : "black",
        ":active": {
          backgroundColor: "rgba(242, 102, 57, 0.7)",
        },
      };
    },
  };

  const projectwbsselect = (e) => {
    if (e) {
      setProjectWbsSelected([{ value: e.value, label: e.label }]);
    } else {
      setProjectWbsSelected([]);
    }
  };
  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        {UserData.data.role === "admin" ? (
          <Header breadCrumbsData={adminBreadcrumbsData} heading="" />
        ) : (
          <Header breadCrumbsData={breadcrumbsData} heading="" />
        )}

        <div
          className="row"
          style={{
            justifyContent: "flex-end",
            alignItems: "center",
            padding: "20px",
          }}
        >
          <div className="col-sm-2 col-lg-2 col-md-2 col-form">
            <label htmlFor="plant" className="form-label">
              {" "}
              PLANT<span style={{ color: "red" }}>*</span>
            </label>
            <div>
              <Select
                className="Selects"
                styles={customStyles}
                isClearable={true}
                name="plant"
                id="plant"
                options={[
                  { value: "all", label: "All" },
                  ...(plantNameFeeder?.map(({ id, plant }) => ({
                    value: id,
                    label: plant,
                  })) || []),
                ]}
                value={plantSelected}
                onChange={(e) => {
                  if (e) {
                    setPlantSelected([{ value: e.value, label: e.label }]);
                    setProjectSelected([]);
                    setProjectWbsSelected([]);
                    setProjectWbsNameFeeder([]);
                  } else {
                    setProjectSelected([]);
                    setProjectWbsSelected([]);
                    setProjectWbsNameFeeder([]);
                  }
                }}
              />
            </div>
          </div>
          <div className="col-sm-2 col-lg-2 col-md-2 col-form">
            {/* -----------Project--------------- */}
            <label htmlFor="project" className="form-label">
              {" "}
              PROJECT<span style={{ color: "red" }}>*</span>
            </label>
            <div>
              <Select
                className="Selects"
                isClearable={true}
                styles={customStyles}
                name="project"
                options={[
                  { value: "all", label: "All" },
                  ...(projectNameFeeder?.map(({ id, project }) => ({
                    value: id,
                    label: project,
                  })) || [
                    {
                      value: "noneSelected",
                      label: "Select a plant to view projects.",
                      isDisabled: true,
                    },
                  ]),
                ]}
                value={projectSelected}
                onChange={(e) => {
                  if (e) {
                    setProjectSelected([{ value: e.value, label: e.label }]);
                    setProjectWbsSelected([]);
                  } else {
                    setProjectWbsSelected([]);
                    setProjectSelected([]);
                  }
                }}
              />
            </div>
          </div>
          {/* 
          {/* <div className="col-sm-2 col-lg-2 col-md-2 col-form">
            {/* <----------------Project WBS---------------------> */}
          {/* <label htmlFor="plant" className="form-label">
              {" "}
              PROJECT WBS */}
          {/* </label>
            <div>
              <Select
                className="Selects"
                isClearable={true}
                styles={customStyles}
                defaultValue={defaultvalue[0]}
                onChange={(e) => {
                  projectwbsselect(e);
                }}
                options={[
                  { value: "all", label: "All" },
                  ...(projectWbsNameFeeder?.map(({ id, project_wbs }) => ({
                    value: id,
                    label: project_wbs,
                  })) || []),
                ]}
                value={projectWbsSelected}
              />
            </div>
          </div> */}

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginRight: "20px",
            }}
          >
            <label htmlFor="plant" className="form-label">
              MODE
            </label>
            <SelectPicker
              value={clientStatus}
              searchable={false}
              onChange={setClientStatus}
              data={clientStatusData}
              style={{ width: 224 }}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label htmlFor="plant" className="form-label">
              EMAIL STATUS
            </label>
            <SelectPicker
              value={emailStatus}
              searchable={false}
              onChange={setEmailStatus}
              data={emailStatusData}
              style={{ width: 224 }}
            />
            {/* <div>
              <Select
                className="Selects"
                isClearable={true}
                styles={customStyles}
                defaultValue={[0]}
                onChange={setEmailStatus}
                options={emailStatusData}
                value={emailStatus}
              />
            </div> */}
          </div>
          <div class="col-sm-2   col-auto">
            {" "}
            <label htmlFor="plant" className="form-label">
              {" "}
              DATE SELECTOR
            </label>
            <div className="datepicker_dash">
              <DateRangePicker
                defaultValue={[new Date(), new Date()]}
                placement={"auto"}
                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                style={{ width: 300, float: "right" }}
                onChange={(e) => {
                  if (e != null) {
                    setrange([]);
                    e.forEach((newValue) => {
                      var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                      var localISOTime = new Date(newValue - tzoffset)
                        .toISOString()
                        .slice(0, -1);
                      handlechangedate("validtill", localISOTime);
                    });
                  }
                }}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-3 col-sm-6 col-12 ">
            <div class="card">
              <div class="card-body" style={{ padding: "1.5rem" }}>
                <div class="dash-widget-header">
                  <span class="dash-widget-icon text-danger border-danger">
                    <i class="bi bi-person-vcard-fill"></i>
                  </span>
                  <div class="dash-count">
                    <h3>{datacount?.values}</h3>
                  </div>
                </div>
                <div class="dash-widget-info">
                  <h6 class="text-muted">Invoice</h6>
                  <div class="progress progress-sm">
                    <div
                      class="progress-bar bg-danger"
                      style={{ width: `${datacount.values / 10}%` }}
                      aria-valuenow={datacount.values}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 col-12 ">
            <div class="card">
              <div class="card-body" style={{ padding: "1.5rem" }}>
                <div class="dash-widget-header">
                  <span class="dash-widget-icon text-danger border-danger">
                    <i class="bi bi-check-circle-fill"></i>
                  </span>
                  <div class="dash-count">
                    <h3>{datacount?.sent}</h3>
                  </div>
                </div>
                <div class="dash-widget-info">
                  <h6 class="text-muted">Sent</h6>
                  <div class="progress progress-sm">
                    <div
                      class="progress-bar bg-danger"
                      style={{ width: `${datacount.sent / 10}%` }}
                      aria-valuenow={datacount.sent}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 col-12 ">
            <div class="card">
              <div class="card-body" style={{ padding: "1.5rem" }}>
                <div class="dash-widget-header">
                  <span class="dash-widget-icon text-danger border-danger">
                    <i class="bi bi-x-circle-fill"></i>
                  </span>
                  <div class="dash-count">
                    <h3>{datacount?.failed}</h3>
                  </div>
                </div>
                <div class="dash-widget-info">
                  <h6 class="text-muted">Failed</h6>
                  <div class="progress progress-sm">
                    <div
                      class="progress-bar bg-danger"
                      style={{ width: `${datacount.failed / 10}%` }}
                      aria-valuenow={datacount.failed}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="UserDetails">
          <button
            style={{
              background:
                "linear-gradient(90deg, #F26639 -3.66%, #F79C37 -3.65%, #EF4D39 100.34%)",
            }}
            className="custom-button mr-3"
            onClick={() => navigate("/create_schedule")}
          >
            CREATE
          </button>
          <div className="split-download" ref={dropdownRef}>
            {/* Default Button */}
            <button
              className="main-btn"
              onClick={() => {
                exceldatadownload("excel");
              }}
              style={{
                background:
                  "linear-gradient(90deg, #F26639 -3.66%, #F79C37 -3.65%, #EF4D39 100.34%)",
              }}
            >
              Download Excel
            </button>

            {/* Arrow Button */}
            <button className="arrow-btn" onClick={() => setOpen(!open)}>
              ▼
            </button>

            {/* Dropdown */}
            {open && (
              <div className="downloadDropdown">
                <div
                  className="downloadDropdown-item"
                  onClick={() => {
                    exceldatadownload("excel");
                    setOpen(false);
                  }}
                >
                  <PiMicrosoftExcelLogoFill size={22} color="#F26639" />
                  Excel
                </div>
                <div
                  className="downloadDropdown-item"
                  onClick={() => {
                    exceldatadownload("pdf");
                    setOpen(false);
                  }}
                >
                  <FaRegFilePdf size={20} color="#F26639" />
                  PDF
                </div>
              </div>
            )}
          </div>
        </div>

        <ReactTable
          columns={InvoiceColumn}
          data={tabledata}
          pagesize={pagesize}
          pageindex={pageindex}
          dtpagesize={dtpagesize}
          dtpageindex={dtpageindex}
          datacount={tableDatacount}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          search={true}
        />
      </div>
    </>
  );
};

export default Role;
